
export abstract class AbstractAuthService {

  abstract loginWithEmailAndPassword(email: string, password: string): void;
  abstract logout(): void;

}
